import { render } from "./Hosts.vue?vue&type=template&id=5cc32a63"
import script from "./Hosts.vue?vue&type=script&lang=js"
export * from "./Hosts.vue?vue&type=script&lang=js"
script.render = render

export default script